import React from 'react';
export function Footer() {
  return <footer className="px-4 py-8 text-center text-brand-cream/60" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <p className="mb-2 font-bold text-brand-cream" data-id="element-106">Punto ebook</p>
        <p className="text-sm" data-id="element-107">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}